import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { map, Observable, of } from 'rxjs';
import { AppSettingService } from 'src/app/core/services/appsetting';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  constructor(
    oAuthService: OAuthService,
  ) {
    oAuthService.initImplicitFlow();
  }
}
